import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { useAuth } from "../../hooks/use-auth";
import { useToast } from "../../contexts/toast/toast-context";
import { getApiErrorMessage } from "../../utils";
import { ForgotPasswordModal } from "../../components/forgot-password-modal";
import { LoadingButton } from "../../components/button/loading-button";
import { AnimatedNetworkBackground } from "../Home/components/animated-network-background";

export default function Login() {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const { info, error } = useToast();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [modalRecuperacaoAberto, setModalRecuperacaoAberto] = useState(false);

  useEffect(() => {
    if (user) {
      navigate("/painel");
    }
  }, [navigate, user]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    try {
      setIsSubmitting(true);
      const res = await api.post("/auth/login", { email, password: senha });

      const { access_token } = res.data;

      login(access_token);
      info(`Bem vindo!`);
      navigate("/painel");
    } catch (err) {
      const apiMessage = getApiErrorMessage(err);
      error(apiMessage);
      setErro(apiMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="relative isolate flex min-h-screen items-center justify-center overflow-hidden bg-blue-950 bg-cover bg-center px-4 py-10">
      <AnimatedNetworkBackground />
      <div className="pointer-events-none absolute inset-0 z-10 bg-blue-950/70" />
      {/* <div className="pointer-events-none absolute inset-0 z-10 bg-grid opacity-20" /> */}

      <form
        onSubmit={handleLogin}
        className="app-card-elevated relative z-20 w-full max-w-md bg-white/95 p-8 backdrop-blur-sm"
      >
        <div className="flex flex-col items-center justify-center mb-6">
          <img
            src="/img/sengia-logo-horizontal.png"
            alt="Sengia"
            className="mb-4 h-auto w-full max-w-[260px]"
          />
        </div>
        <label className="form-label">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="form-input mb-4"
          autoComplete="email"
          required
        />
        <label className="form-label">Senha</label>
        <input
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          className="form-input mb-4"
          autoComplete="current-password"
          required
        />
        {erro && (
          <p className="mb-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {erro}
          </p>
        )}
        <LoadingButton
          type="submit"
          className="btn btn-primary w-full cursor-pointer"
          isLoading={isSubmitting}
          loadingLabel="Entrando"
        >
          Entrar
        </LoadingButton>
        <div>
          <button
            type="button"
            onClick={() => {
              setModalRecuperacaoAberto(true);
            }}
            className="btn-link-primary py-2 text-sm"
          >
            Esqueceu a senha?
          </button>
        </div>
      </form>

      <ForgotPasswordModal
        isOpen={!!modalRecuperacaoAberto}
        title="Recuperação de Senha"
        description="Digite seu email"
        onCancel={() => setModalRecuperacaoAberto(false)}
        onSend={() => setModalRecuperacaoAberto(false)}
      />
    </div>
  );
}
